import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientNote } from "../../models/ClientNotes";
import { createClientNote, fetchNotesByClientId, needToLoadClientNotes } from "./actions";

interface ClientNotesState {
    clientNotes: ClientNote[],
    isLoading: boolean,
    error: string | null,
    needToLoadNotes: boolean
}

const initialState: ClientNotesState = {
    clientNotes: [],
    isLoading: false,
    error: null,
    needToLoadNotes: true
}

const clientNotesSlice = createSlice({
    name: "clientNotes",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotesByClientId.pending, (state) => {
                state.isLoading = true;
                state.error = null
            })
            .addCase(fetchNotesByClientId.fulfilled, (state, action: PayloadAction<ClientNote[]>) => {
                state.isLoading = false;
                state.clientNotes = action.payload;
            })
            .addCase(fetchNotesByClientId.rejected, (state, action: any) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(createClientNote.pending, (state) => {
                state.isLoading = true;
                state.error = null
            })
            .addCase(createClientNote.fulfilled, (state, action: PayloadAction<ClientNote>) => {
                state.isLoading = false;
                state.clientNotes = state.clientNotes.concat(action.payload);
            })
            .addCase(createClientNote.rejected, (state, action: any) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(needToLoadClientNotes.fulfilled, (state, action: PayloadAction<boolean>) => {
                state.needToLoadNotes = action.payload;
                if(action.payload) {
                    state.clientNotes = [];
                }
            })
    }
})

export default clientNotesSlice.reducer;